import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)

export default new Router({
    routes: [{
            path: '/',
            redirect: 'index',
            component: () =>
                import ('../components/front/frame.vue'),
            children: [{
                path: 'index',
                name: 'index',
                component: (resolve) => require(['../components/front/Index.vue'], resolve)
            }, {
                path: 'myblog',
                name: 'MyBlog',
                component: (resolve) => require(['../components/front/MyBlog.vue'], resolve)
            },
            {
                path: 'threejs',
                name: 'threejs',
                component: (resolve) => require(['../components/front/shinei.vue'], resolve)
            }, {
                path: 'chatroom',
                name: 'chatroom',
                component: (resolve) => require(['../components/front/chatroom.vue'], resolve)
            }]
    },
        {
            path: '/admin',
            redirect: '/admin/welcome',
            name: 'admin',
            component: () =>
                import ('../components/admin/Index.vue'),
            children: [{
                path: 'welcome',
                name: 'welcome',
                component: (resolve) => require(['../components/admin/components/welcome.vue'], resolve)
            },
                {
                    path: 'category',
                    name: 'category',
                    component: (resolve) => require(['../components/admin/components/category.vue'], resolve)
                },
                {
                    path: 'detail',
                    name: 'detail',
                    component: (resolve) => require(['../components/admin/components/detail.vue'], resolve)
                },
                {
                    path: 'addDetail',
                    name: 'addDetail',
                    component: (resolve) => require(['../components/admin/components/addDetail.vue'], resolve)
                }
            ]
        },

    ]
})